import { useState } from 'react'

import type { UseRedactAccountModalReturn, RedactAccount } from './useRedactAccountModal.types'

export function useRedactAccountModal(): UseRedactAccountModalReturn {
  const [selectedAccount, setSelectedAccount] = useState<RedactAccount | undefined>(undefined)

  const openModal = (account: RedactAccount) => {
    setSelectedAccount(account)
  }

  const closeModal = () => {
    setSelectedAccount(undefined)
  }

  return {
    selectedAccount,
    isModalOpen: !!selectedAccount,
    openModal,
    closeModal
  }
}
